import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import Script from 'next/script'
import { useState } from 'react'

import { APPLE_APP_ID } from 'src/config/apps'

import AppleButton from './AppleButton'

let isLoadedScript = false

type Props = {
  title: string
  authType: SocialAuthTypes
  disabled?: boolean
  skipTrackEvent?: boolean
}

export default function AppleAuthButton(props: Props) {
  const [isLoading, setIsLoading] = useState(isLoadedScript)

  return (
    <>
      <Script
        id='apple signin'
        src='https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
        onLoad={() => {
          window.AppleID.auth.init({
            clientId: APPLE_APP_ID,
            scope: 'email',
            redirectURI: `${window.location.origin}/`,
            state: 'origin:web',
            usePopup: true,
          })

          isLoadedScript = true
          setIsLoading(isLoadedScript)
        }}
        onError={(err) => {
          console.log('apple id failed to load', err)
        }}
      />
      <AppleButton
        title={props.title}
        authType={props.authType}
        disabled={!isLoading || props.disabled}
        skipTrackEvent={props.skipTrackEvent}
      />
    </>
  )
}
